import { useRouter } from 'next/router';

import { useResponsive } from './useResponsive';
import { UNSUPPORTED_CHATBOT_LOCALES } from '../constants';
import { useStore } from '../zustand/stores';

const useIsArticlePageRedesignUnifiedUXEnabled = () => {
  const { locale } = useRouter();
  const { isMobile } = useResponsive();
  const { user } = useStore((state) => state.userSlice);

  if (!user || isMobile || UNSUPPORTED_CHATBOT_LOCALES.includes(locale as string)) {
    return false;
  }

  return true;
};

export default useIsArticlePageRedesignUnifiedUXEnabled;
